import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["month", "year", "hidden"];

  update() {
    const month = this.monthTarget.value;
    const year = this.yearTarget.value;

    if (month && year) {
      const paddedMonth = month.padStart(2, "0");
      this.hiddenTarget.value = `${year}-${paddedMonth}-01T00:00:00.000Z`;
    } else {
      this.hiddenTarget.value = "";
    }
  }
}
